import { z } from 'zod';
export const jsonEditorField = z.preprocess(value => {
  if (value === null || value === undefined) return [];
  if (Array.isArray(value)) {
    return value.filter(item => item !== null && item !== undefined);
  }
  if (typeof value === 'object') return [value];
  return value;
}, z.array(z.object({}).catchall(z.unknown()))).default([]);
export type JsonEditorField = z.infer<typeof jsonEditorField>;